import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { MachineBuilder } from '../../models/builders/machine.builder';
import { Machine } from '../../models/machine';

const saveMachineBody = (machine: Machine) => ({
   name: machine.name,
   active: machine.active,
   fileType: machine.fileType,
   path: machine.path,
   inputPath: machine.inputPath,
   outputPath: machine.outputPath,
   successPath: machine.successPath,
   failedPath: machine.failedPath
});

@Injectable()
export class MachineApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}machines`;
  }

  getMachines() {
    return this.httpClient.get(`${this.apiUrl}`).pipe(map(MachineBuilder.fromList));
  }

  getMachine(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(
        map(MachineBuilder.fromJson)
      );
  }

  updateMachine(machine: Machine) {
    return this.httpClient.put(`${this.apiUrl}/${machine.hash}`, saveMachineBody(machine));
  }

  getActiveMachine() {
    return this.httpClient.get(`${this.apiUrl}/active`)
      .pipe(
        map(MachineBuilder.fromJson)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/machine-api.service.ts